export default __webpack_public_path__ + "static/media/umbrella.d8e798fc.jpg";